var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-center btn-cu btn-l btn-fw bt_ctrib",attrs:{"aria-disabled":_vm.isLoaded,"id":"loginClaveTributaria"},on:{"click":_vm.signInClaveTributaria}},[_c('img',{attrs:{"src":_vm.claveTributariaTxt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }